import KdiagramCalculationResultTableData from "./data";

export default function mapTableDataFromJson(json) {
  let dataObject = json;
  if (typeof json.data === "string") {
    dataObject = JSON.parse(json.data);
  }

  const table = dataObject["values_table"];

  return new KdiagramCalculationResultTableData(
    table["daily_consumption"],
    table["Power"],
    table["Power_Interval_kW"],
    table["Power_Interval_pct"],
    table["Speed"],
    table["rpm"],
    table["iso_daily_consumption"],
    table["auxiliary_consumption"],
    table["measured_iso_consumption"],
    table["median_measured_consumption"],
  );
}
